// Device-local pin of the employee shown in the identification gate. Visual only.
export const FIXED_EMPLOYEE_STORAGE_KEY = 'posFixedEmployeeId';

export function getFixedEmployeeId(): number | null {
  const raw = localStorage.getItem(FIXED_EMPLOYEE_STORAGE_KEY);
  if (!raw) return null;
  const parsed = Number(raw);
  return Number.isInteger(parsed) ? parsed : null;
}

export function setFixedEmployeeId(employeeId: number): void {
  localStorage.setItem(FIXED_EMPLOYEE_STORAGE_KEY, String(employeeId));
}

export function clearFixedEmployeeId(): void {
  localStorage.removeItem(FIXED_EMPLOYEE_STORAGE_KEY);
}
